import { FormGroup as _FormGroup, FormGroupProps as _FormGroupProps } from "reactstrap";

    export const FormGroup = _FormGroup;
    export type FormGroupProps = _FormGroupProps;
    